var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"选择报警设备","modal":false,"visible":_vm.showBlock,"show-close":true,"width":"800px","before-close":_vm.closedBtn,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.showBlock=$event}}},[_c('div',[_vm._v(" 12324123 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }